// MemberCardModal.jsx
import React from "react";
import { Modal, Image } from "react-bootstrap";
import { QRCodeSVG } from "qrcode.react";
import LeftArrow from "../../assets/images/committee/ArrowLeft.svg";

const MemberCardModal = ({ show, onHide, user }) => {
  if (!user) return null;

  const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";
  const profileImage =
    user?.profile_picture || user?.profile_picture_path || user?.image || "";
  const fullProfileUrl = profileImage
    ? profileImage.startsWith("http")
      ? profileImage
      : `${IMAGE_BASEURL}${profileImage}`
    : null;

  const initials =
    `${user?.first_name?.[0] || ""}${user?.last_name?.[0] || ""}`.toUpperCase();

  return (
    <Modal show={show} onHide={onHide} centered className="member-card-modal">
      <Modal.Header className="member-card-header">
        <h5 className="mb-0 fw-bold text-main mx-auto">My Profile</h5>
        <button
          className="member-card-close-btn"
          onClick={onHide}
          aria-label="Close"
        >
          ✕
        </button>
      </Modal.Header>

      <Modal.Body className="member-card-body">
        {/* Profile Strip */}
        <div className="member-profile-strip">
          <div className="member-card-avatar">
            {fullProfileUrl ? (
              <Image src={fullProfileUrl} className="member-card-photo" />
            ) : (
              <span className="member-card-initials">{initials}</span>
            )}
          </div>
          <div>
            <div className="member-card-name">
              {user.first_name} {user.last_name}
            </div>
            <div className="member-card-id">{user.gstb_seq_id || "N/A"}</div>
          </div>
        </div>

        {/* QR Code Card */}
        <div className="member-qr-card">
          {/* <p className="member-qr-label">Member QR Code</p> */}
          <div className="member-qr-box">
            <QRCodeSVG
              value={user.gstb_seq_id || "GSTB-MEMBER"}
              size={220}
              level="H"
              includeMargin={false}
            />
          </div>
          {/* <p className="member-qr-hint">Scan to verify membership</p> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MemberCardModal;
